import { render, staticRenderFns } from "./SubmitButtonEvento.vue?vue&type=template&id=6f337c1b&scoped=true"
import script from "./SubmitButtonEvento.vue?vue&type=script&lang=js"
export * from "./SubmitButtonEvento.vue?vue&type=script&lang=js"
import style0 from "./SubmitButtonEvento.vue?vue&type=style&index=0&id=6f337c1b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f337c1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cleverton/paytour-payt-1702/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f337c1b')) {
      api.createRecord('6f337c1b', component.options)
    } else {
      api.reload('6f337c1b', component.options)
    }
    module.hot.accept("./SubmitButtonEvento.vue?vue&type=template&id=6f337c1b&scoped=true", function () {
      api.rerender('6f337c1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/apps/calendario_venda/components-evento/SubmitButtonEvento.vue"
export default component.exports